import React from "react";
import {
  FlippingCard,
  FlippingCardBack,
  FlippingCardFront,
} from "react-ui-cards";

import { Row, Col, Container } from "react-bootstrap";

import "./css/Team.css";
import ParticleBackground from "./ParticleBackground";

const Team = () => {
  return (
    <div>
      <ParticleBackground />
      <Container fluid="sm">
        <Row
          className="justify-content-md-center"
          style={{ marginTop: "50px", marginLeft: "5%" }}
        >
          <Col lg={3} md={6}>
            <FlippingCard className="mobile">
              <FlippingCardBack>
                <div class="back">
                  <div className="inner">
                    <a
                      href={"https://www.instagram.com/aviral_25_/"}
                      style={{ color: "white" }}
                    >
                      <p className="icon">
                        <i className="fab fa-instagram fa-2x"></i>
                      </p>
                    </a>
                    <a
                      onClick={() => {
                        window.location.href = `mailto:anagpal2_be19@thapar.edu?subject=Subject&body=Your message goes here`;
                      }}
                      style={{ color: "white" }}
                    >
                      <p className="icon">
                        <i className="fas fa-envelope fa-2x"></i>
                      </p>
                    </a>
                  </div>
                </div>
              </FlippingCardBack>
              <FlippingCardFront>
                <div
                  className="front "
                  style={{
                    backgroundImage: "url(images/aviral.jpg)",
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                  }}
                >
                  <div class="inner">
                    <p style={{ marginTop: "-20px" }}>Aviral Nagpal</p>
                    <span></span>
                  </div>
                </div>
              </FlippingCardFront>
            </FlippingCard>
          </Col>

          <Col lg={3} md={6}>
            <FlippingCard className="mobile">
              <FlippingCardBack>
                <div class="back">
                  <div className="inner">
                    <a
                      href={"https://www.instagram.com/japneet_1505/"}
                      style={{ color: "white" }}
                    >
                      <p className="icon">
                        <i className="fab fa-instagram fa-2x"></i>
                      </p>
                    </a>
                    <a
                      onClick={() => {
                        window.location.href = `mailto:jkaur2_be19@thapar.edu?subject=Subject&body=Your message goes here`;
                      }}
                      style={{ color: "white" }}
                    >
                      <p className="icon">
                        <i className="fas fa-envelope fa-2x"></i>
                      </p>
                    </a>
                  </div>
                </div>
              </FlippingCardBack>
              <FlippingCardFront>
                <div
                  className="front "
                  style={{
                    backgroundImage: "url(images/japneet.jpeg)",
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                  }}
                >
                  <div class="inner">
                    <p style={{ marginTop: "-20px" }}>Japneet Kaur</p>
                    <span></span>
                  </div>
                </div>
              </FlippingCardFront>
            </FlippingCard>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Team;
